/* eslint-disable */
import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Loading from '../../components/loading/Loading';
import FlashContext from '../../components/contexts/FlashContext';
import api from '../../service/axios/api';

const StyledTableCell = withStyles(() => ({
  head: { backgroundColor: '#303474', color: 'white' },
  body: { fontSize: 14 },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// Adicione as funções de máscara (mesmas do Suppliers.jsx)
const maskCnpj = v => v.replace(/\D/g, '')
  .replace(/^(\d{2})(\d)/, '$1.$2')
  .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
  .replace(/\.(\d{3})(\d)/, '.$1/$2')
  .replace(/(\d{4})(\d)/, '$1-$2')
  .slice(0, 18);

const maskCpf = (v) => v.replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .slice(0, 14)

const maskPhone = v => v.replace(/\D/g, '')
  .replace(/^(\d{2})(\d)/, '($1) $2')
  .replace(/(\d{4})(\d)/, '$1-$2')
  .slice(0, 14);

const maskMobile = v => v.replace(/\D/g, '')
  .replace(/^(\d{2})(\d)/, '($1) $2')
  .replace(/(\d{5})(\d)/, '$1-$2')
  .slice(0, 15);

const maskPostalCode = v => {
  const cep = v.replace(/\D/g, '').slice(0, 8);
  return cep.length > 5 ? cep.replace(/(\d{5})(\d)/, '$1-$2') : cep;
};

export function SuppliersTableRow({ docs, searchData }) {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // Estados do delete
  const [openDelete, setOpenDelete] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  // Estados do edit
  const [openEdit, setOpenEdit] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);

  // Campos do formulário de edição
  const [editName, setEditName] = useState('');
  const [editContact, setEditContact] = useState('');
  const [editCnpj, setEditCnpj] = useState('');
  const [editCpf, setEditCpf] = useState('');
  const [editPhone, setEditPhone] = useState('');
  const [editMobile, setEditMobile] = useState('');
  const [editEmail, setEditEmail] = useState('');
  const [editPostalCode, setEditPostalCode] = useState('');
  const [editStreet, setEditStreet] = useState('');
  const [editNumber, setEditNumber] = useState('');
  const [editComplement, setEditComplement] = useState('');
  const [editDistrict, setEditDistrict] = useState('');
  const [editCity, setEditCity] = useState('');
  const [editUf, setEditUf] = useState('');

  // Abre o edit já preenchido com os dados atuais
 const handleOpenEdit = () => {
  setEditName(docs.supplier_name || '');
  setEditContact(docs.contact_name || '');
  setEditCnpj(maskCnpj(docs.cnpj || ''));           // ← máscara
  setEditCpf(maskCpf(docs.cpf || ''));
  setEditPhone(maskPhone(docs.phone || ''));          // ← máscara
  setEditMobile(maskMobile(docs.mobile || ''));       // ← máscara
  setEditEmail(docs.email || '');
  setEditPostalCode(maskPostalCode(docs.postal_code || '')); // ← máscara
  setEditStreet(docs.street_name || '');
  setEditNumber(docs.number || '');
  setEditComplement(docs.complement || '');
  setEditDistrict(docs.district || '');
  setEditCity(docs.city || '');
  setEditUf(docs.state || '');
  setAnchorEl(null);
  setOpenEdit(true);
};
  const handleCepEdit = async valor => {
      const cep = valor.replace(/\D/g, '').slice(0, 8);
      const formatted = cep.length > 5 ? cep.replace(/(\d{5})(\d)/, '$1-$2') : cep;
      setEditPostalCode(formatted); 

    if (cep.length === 8) {
      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
        if (response.data.erro) {
          notifyError('CEP não encontrado');
          return;
        }
        setEditStreet(response.data.logradouro);
        setEditDistrict(response.data.bairro);
        setEditCity(response.data.localidade);
        setEditUf(response.data.uf);
      } catch (error) {
        notifyError(error.message);
      }
    } else if (cep.length === 0) {
      setEditStreet('');
      setEditDistrict('');
      setEditCity('');
      setEditUf('');
    }
  };

  const handleDelete = async () => {
    setLoadingDelete(true);
    try {
      const res = await api.supplier.delete(docs.id);
      notifySuccess(res.data.message);
      setOpenDelete(false);
      searchData();
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleEdit = async () => {
    if (editName.trim().length === 0) {
      notifyError('Nome é obrigatório');
      return;
    }
    if (editCnpj.trim().length === 0 && editCpf.trim().length == 0) {
      notifyError('CNPJ ou CPF são obrigatórios');
      return;
    }

    setLoadingEdit(true);
    try {
      const res = await api.supplier.edit(
        docs.id,
        editName,
        editContact,
        editCnpj,
        editCpf,
        editPhone,
        editMobile,
        editEmail,
        editPostalCode,
        editStreet,
        editNumber,
        editComplement,
        editDistrict,
        editCity,
        editUf,
      )
      notifySuccess(res.data.message);
      setOpenEdit(false);
      searchData();
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoadingEdit(false);
    }
  };

  return (
    <>
      <StyledTableRow>
        <StyledTableCell>{docs.supplier_name || '-'}</StyledTableCell>
        <StyledTableCell>{docs.contact_name || '-'}</StyledTableCell>
        <StyledTableCell>{docs.cnpj || '-'}</StyledTableCell>
        <StyledTableCell>{docs.cpf || '-'}</StyledTableCell>
        <StyledTableCell>{docs.phone || '-'}</StyledTableCell>
        <StyledTableCell>
          <MoreVertIcon
            onClick={e => setAnchorEl(e.currentTarget)}
            fontSize="small"
            style={{ cursor: 'pointer' }}
          />
        </StyledTableCell>
        <StyledTableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </StyledTableCell>
      </StyledTableRow>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={handleOpenEdit}>Editar</MenuItem>
        <MenuItem onClick={() => { setOpenDelete(true); setAnchorEl(null); }}>
          Excluir
        </MenuItem>
      </Menu>

      {/* Linha expandida */}
      <TableRow>
        <TableCell colSpan={7} style={{ padding: 0, borderBottom: open ? undefined : 'none' }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box padding={2} style={{ backgroundColor: '#f9f9f9' }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={2}>
                  <strong>Celular</strong>
                  <p style={{ margin: '4px 0 0' }}>{docs.mobile || '-'}</p>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <strong>E-mail</strong>
                  <p style={{ margin: '4px 0 0' }}>{docs.email || '-'}</p>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <strong>Endereço</strong>
                  <p style={{ margin: '4px 0 0' }}>
                    {docs.street_name && docs.number ? `${docs.street_name}, ${docs.number}` : '-'}
                  </p>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <strong>Cidade / UF</strong>
                  <p style={{ margin: '4px 0 0' }}>
                    {docs.city && docs.state ? `${docs.city} / ${docs.state}` : '-'}
                  </p>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <strong>CEP</strong>
                  <p style={{ margin: '4px 0 0' }}>{docs.postal_code || '-'}</p>
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {/* Dialog de Delete */}
      <Dialog open={openDelete} onClose={() => setOpenDelete(false)} fullWidth maxWidth="sm">
        <Loading open={loadingDelete} msg="Excluindo..." />
        <DialogTitle>Excluir Fornecedor</DialogTitle>
        <DialogContent>
          <Grid container spacing={4} style={{ justifyContent: 'center' }}>
            <Grid item xs={12} sm={8}>
              <p style={{ fontSize: '20px', textAlign: 'justify' }}>
                {`Deseja excluir o fornecedor ${docs.supplier_name}? Esta ação não pode ser desfeita.`}
              </p>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDelete(false)} variant="text" color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDelete} variant="contained" style={{ backgroundColor: 'red', color: 'white' }}>
            Excluir
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Edit */}
      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
        <Loading open={loadingEdit} msg="Salvando..." />
        <DialogTitle>Editar Fornecedor</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} style={{ justifyContent: 'center', marginTop: 4 }}>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Nome" variant="outlined" value={editName} onChange={e => setEditName(e.target.value)} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Contato" variant="outlined" value={editContact} onChange={e => setEditContact(e.target.value)} />
            </Grid>
            <Grid item sm={6} xs={12}>
               <TextField fullWidth label="CNPJ" variant="outlined" value={editCnpj} onChange={e => setEditCnpj(maskCnpj(e.target.value))} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="CPF" variant="outlined" value={editCpf} onChange={e => setEditCpf(maskCpf(e.target.value))} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Telefone" value={editPhone} variant="outlined" onChange={e => setEditPhone(maskPhone(e.target.value))} placeholder="(00) 0000-0000" inputProps={{ maxLength: 14 }} />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Celular" value={editMobile} variant="outlined" onChange={e => setEditMobile(maskMobile(e.target.value))}placeholder="(00) 00000-0000" inputProps={{ maxLength: 15 }} />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="E-mail" variant="outlined" value={editEmail} onChange={e => setEditEmail(e.target.value)} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="CEP" variant="outlined" value={editPostalCode} onChange={e => handleCepEdit(e.target.value)} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Logradouro" variant="outlined" value={editStreet} disabled />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Número" variant="outlined" value={editNumber} onChange={e => setEditNumber(e.target.value)} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Complemento" variant="outlined" value={editComplement} onChange={e => setEditComplement(e.target.value)} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Bairro" variant="outlined" value={editDistrict} disabled />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="Cidade" variant="outlined" value={editCity} disabled />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField fullWidth label="UF" variant="outlined" value={editUf} disabled />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEdit(false)} variant="text" color="primary">
            Cancelar
          </Button>
          <Button onClick={handleEdit} variant="contained" color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}